import { showErrorMessage } from 'actions/messages';
import {
  GENERAL_CONTRACTORS_LOAD_SUCCESS,
  GENERAL_CONTRACTORS_PAGE_CHANGE,
  NEXT_STAGE,
  LICENCE_NUMBER_VALUE_CHANGE,
  NEW_ONBOARDING,
  COMPANY_LOGO_FILE_SET,
  GENERAL_CONTRACTOR_LOAD_SUCCESS,
  GENERAL_CONTRACTOR_ONBOARDING_STAGE_CHANGE,
  GENERAL_CONTRACTOR_PROJECTS_LOAD_SUCCESS,
  GENERAL_CONTRACTOR_PROJECTS_PAGE_CHANGE,
  GENERAL_CONTRACTORS_CONTACTS_MODAL_SHOW,
  GENERAL_CONTRACTORS_USERS_SET,
} from 'components/admin/general-contractors/store/action-types';
import { generalContractorsApi } from 'services/api/general-contractors-api';
import { push } from 'react-router-redux';

export const baseRoutePath = '/admin/general-contractors';

export function addGeneralContractor() {
  return (dispatch) => {
    dispatch(push(`${baseRoutePath}/new`));
  };
}

export function showGeneralContractorDetails(id) {
  return (dispatch) => {
    dispatch(push(`${baseRoutePath}/${id}`));
  };
}

export function goToEditGeneralContractor(generalContractorId) {
  return (dispatch) => {
    dispatch(push(`${baseRoutePath}/${generalContractorId}/edit`));
  };
}

export function loadGeneralContractorProjectsRequest(
  generalContractorId,
  page,
  status
) {
  return (dispatch) => {
    return generalContractorsApi
      .getGeneralContractorProjects(generalContractorId, page, status)
      .then((response) => {
        if (response.ok) {
          dispatch(loadGeneralContractorsProjectsSuccess(response.projects));
          dispatch(projectsChangePage(page));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function loadGeneralContractorsProjectsSuccess(projects) {
  return {
    type: GENERAL_CONTRACTOR_PROJECTS_LOAD_SUCCESS,
    payload: projects,
  };
}

export function projectsChangePage(newPage) {
  return {
    type: GENERAL_CONTRACTOR_PROJECTS_PAGE_CHANGE,
    payload: newPage,
  };
}

export function newOnboarding() {
  return {
    type: NEW_ONBOARDING,
  };
}

export function setStage(value) {
  return {
    payload: value,
    type: GENERAL_CONTRACTOR_ONBOARDING_STAGE_CHANGE,
  };
}

export function nextStage() {
  return {
    type: NEXT_STAGE,
  };
}

export function setLicenceNumberValue(value) {
  return {
    type: LICENCE_NUMBER_VALUE_CHANGE,
    payload: value,
  };
}

export function setCompanyLogo(file) {
  return {
    type: COMPANY_LOGO_FILE_SET,
    payload: file,
  };
}

export function loadGeneralContractorSuccess(generalContractor) {
  return {
    type: GENERAL_CONTRACTOR_LOAD_SUCCESS,
    payload: generalContractor,
  };
}

export function loadGeneralContractorRequest(contractorId) {
  return (dispatch) => {
    return generalContractorsApi
      .getGeneralContractor(contractorId)
      .then((response) => {
        if (response.ok) {
          dispatch(loadGeneralContractorSuccess(response.generalContractor));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function loadGeneralContractorsRequest(page, status) {
  return (dispatch) => {
    return generalContractorsApi
      .getGeneralContractors(page, status)
      .then((response) => {
        if (response.ok) {
          dispatch(loadGeneralContractorsSuccess(response.generalContractors));
          dispatch(changePage(page));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function loadGeneralContractorsSuccess(generalContractors) {
  return {
    type: GENERAL_CONTRACTORS_LOAD_SUCCESS,
    payload: generalContractors,
  };
}

export function changePage(newPage) {
  return {
    type: GENERAL_CONTRACTORS_PAGE_CHANGE,
    payload: newPage,
  };
}

export function showList() {
  return (dispatch) => {
    dispatch(push(baseRoutePath));
  };
}

export function showDashboard() {
  return (dispatch) => {
    dispatch(push('/admin/dashboard'));
  };
}

export function showTeamPage() {
  return (dispatch) => {
    dispatch(push('/admin/team'));
  };
}

export function showOnboarding() {
  return (dispatch) => {
    dispatch(push(`${baseRoutePath}/onboarding`));
  };
}

export function showGeneralContractorPage(generalContractorId) {
  return (dispatch) => {
    dispatch(push(`/admin/general-contractors/${generalContractorId}`));
  };
}

export function createGeneralContractor(values) {
  return (dispatch) => {
    return generalContractorsApi
      .createGeneralContractor(values)
      .then((response) => {
        if (response.ok) {
          dispatch(showList()); // load general contractors list again
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function submitOnboarding(onboardingData) {
  return (dispatch) => {
    return generalContractorsApi
      .updateGeneralContractorOnboardingData(onboardingData)
      .then((response) => {
        if (response.ok) {
          dispatch(showDashboard()); // load dashboard again
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function updateGeneralContractorTeam(generalContractorData, teamEdit) {
  return (dispatch) => {
    return generalContractorsApi
      .updateGeneralContractorTeam(generalContractorData)
      .then((response) => {
        if (response.ok) {
          if (teamEdit) {
            dispatch(showTeamPage()); // load team page again
          } else {
            dispatch(showGeneralContractorPage(generalContractorData.id));
          }
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function showContactsModal(value) {
  return {
    type: GENERAL_CONTRACTORS_CONTACTS_MODAL_SHOW,
    payload: value,
  };
}

export function setGeneralContractorUsers(users) {
  return {
    type: GENERAL_CONTRACTORS_USERS_SET,
    payload: users,
  };
}

export function showContactsRequest(contractorId, users) {
  return (dispatch) => {
    if (users.length > 0) {
      dispatch(showContactsModal(true));
    } else {
      return generalContractorsApi.getUsers(contractorId).then((response) => {
        if (response.ok) {
          dispatch(setGeneralContractorUsers(response.users));
          dispatch(showContactsModal(true));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/general-contractors/store/actions.js